export const state = {
  settings: {},
}

export const getters = {
  getSettings: state => path => {
    return state.settings[path]
  },
}

export const mutations = {
  SET_SETTINGS(state, payload) {
    state.settings[payload.name] = payload.params
  },
  CLEAR_SETTINGS(state, payload) {
    state.settings[payload] = null
  },
  CLEAR_STATE(state) {
    state.settings = null
  },
}
